export enum EUserRole {
  Patient = 1
}
